import { render, staticRenderFns } from "./search-input-form.vue?vue&type=template&id=3b18ead0&"
import script from "./search-input-form.vue?vue&type=script&lang=js&"
export * from "./search-input-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports